import React, {
  type CSSProperties,
  type FC,
  type ReactNode,
  useContext,
} from 'react';

import {DragDropContext} from './DragDropContextProvider';
import {type DragRef} from './types';

interface DragHandleProps {
  partRef: DragRef;
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
  onMouseDown?(e: React.MouseEvent): void;
}

export const DragHandle: FC<DragHandleProps> = ({
  children,
  className,
  style,
  partRef,
}) => {
  const context = useContext(DragDropContext);
  const {setDragRef, setMouseDownEvent} = context;
  return (
    <div
      className={'drag-drop-handle ' + (className || '')}
      style={style}
      onMouseDown={e => {
        setDragRef(partRef);
        setMouseDownEvent(e);
      }}>
      {children}
    </div>
  );
};
